import FieldDictionary from '@/classes/clientOnly/permissionTreeResources/dictionaries/fieldDictionary';
import {
    MessengerChannelAccessFields,
} from '@/classes/clientOnly/permissionTreeResources/enums/entityFields/MessengerChannelAccessFields';

export const messengerChannelAccessFieldsDictionary: FieldDictionary<MessengerChannelAccessFields> = [
    {text: 'Benutzerzugang', value: MessengerChannelAccessFields.LOGIN_USER},
    {text: 'Kanaltyp', value: MessengerChannelAccessFields.TYPE},
    {text: 'API-Konfiguration', value: MessengerChannelAccessFields.API_CONFIG},
    {text: 'E-Mail-Adresse', value: MessengerChannelAccessFields.ADDRESS},
    {text: 'WhatsApp-Nummer (ID)', value: MessengerChannelAccessFields.PHONE_NUMBER_ID},
    {text: 'WhatsApp-Nummer', value: MessengerChannelAccessFields.PHONE_NUMBER},
    {text: 'Erzeugungsdatum', value: MessengerChannelAccessFields.CREATED_AT, readOnly: true},
    {text: 'Änderungsdatum', value: MessengerChannelAccessFields.UPDATED_AT, readOnly: true},
];
